'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events').EventEmitter;

var debug = require('debug');

var withIs = require('class-is');

var BaseConnection =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(BaseConnection, _EventEmitter);

  function BaseConnection(_ref) {
    var _this;

    var _switch = _ref._switch,
        name = _ref.name;

    _classCallCheck(this, BaseConnection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseConnection).call(this));
    _this.switch = _switch;
    _this.ourPeerInfo = _this.switch._peerInfo;
    _this.log = debug("libp2p:conn:".concat(name));
    _this.log.error = debug("libp2p:conn:".concat(name, ":error"));
    return _this;
  }
  /**
   * Puts the state into its disconnecting flow
   *
   * @param {Error} err Will be emitted if provided
   * @returns {void}
   */


  _createClass(BaseConnection, [{
    key: "close",
    value: function close(err) {
      this.log("closing connection to ".concat(this.theirB58Id));

      if (err && this._events.error) {
        this.emit('error', err);
      }

      this._state('disconnect');
    }
  }, {
    key: "emit",
    value: function emit(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (eventName === 'error' && !this._events.error) {
        var _this$log;

        (_this$log = this.log).error.apply(_this$log, args);
      } else {
        var _get2;

        (_get2 = _get(_getPrototypeOf(BaseConnection.prototype), "emit", this)).call.apply(_get2, [this, eventName].concat(args));
      }
    }
    /**
     * Gets the current state of the connection
     *
     * @returns {string} The current state of the connection
     */

  }, {
    key: "getState",
    value: function getState() {
      return this._state._state;
    }
    /**
     * Puts the state into encrypting mode
     *
     * @returns {void}
     */

  }, {
    key: "encrypt",
    value: function encrypt() {
      this._state('encrypt');
    }
    /**
     * Puts the state into privatizing mode
     *
     * @returns {void}
     */

  }, {
    key: "protect",
    value: function protect() {
      this._state('privatize');
    }
    /**
     * Puts the state into muxing mode
     *
     * @returns {void}
     */

  }, {
    key: "upgrade",
    value: function upgrade() {
      this._state('upgrade');
    }
    /**
     * Event handler for disconnected.
     *
     * @fires BaseConnection#close
     * @returns {void}
     */

  }, {
    key: "_onDisconnected",
    value: function _onDisconnected() {
      this.log("disconnected from ".concat(this.theirB58Id));
      this.emit('close');
      this.removeAllListeners();
    }
    /**
     * Event handler for privatized
     *
     * @fires BaseConnection#private
     * @returns {void}
     */

  }, {
    key: "_onPrivatized",
    value: function _onPrivatized() {
      this.log("successfully privatized incoming connection");
      this.emit('private', this.conn);
    }
    /**
     * Wraps this.conn with the Switch.protector for private connections
     *
     * @private
     * @fires ConnectionFSM#error
     * @returns {void}
     */

  }, {
    key: "_onPrivatizing",
    value: function _onPrivatizing() {
      var _this2 = this;

      if (!this.switch.protector) {
        return this._state('done');
      }

      this.conn = this.switch.protector.protect(this.conn, function (err) {
        if (err) {
          return _this2.close(err);
        }

        _this2.log("successfully privatized conn to ".concat(_this2.theirB58Id));

        _this2.conn.setPeerInfo(_this2.theirPeerInfo);

        _this2._state('done');
      });
    }
  }]);

  return BaseConnection;
}(EventEmitter);

module.exports = withIs(BaseConnection, {
  className: 'BaseConnection',
  symbolName: 'libp2p-switch/BaseConnection'
});